<div class="ui-g ui-fluid">
  <div class="ui-g-12" style="display: flex; align-items: center;">
    <div class="card ui-g-8 ui-md-6 ui-sm-10 ui-lg-8" style="margin: 0 auto;">
      <div class="ui-g-12">
        <div style="padding: 3%; text-align: center; color: #033366;">
            <div class="ui-g-12">
                <img style="width: 15%;" src="../../assets/images/new-icons/inteli-search.png" alt="">
            </div>
            <h2 style="font-weight: 400; font-size: 38px; color: #073c8f; font-family: poppins;">Búsqueda Inteligente</h2> 
        </div>
      </div>    
      <div class="ui-g-12" style="margin-bottom: 2%;">
        <div class="ui-grid-row item-login">
          <div class="ui-grid-col-12">
                          <span class="ui-float-label">
                              <input id="float-input" type="text" size="30" pInputText formControlName="name"  >
                              <label for="float-input">Nombre:</label>
                          </span>
            <p-message severity="error" text="nombre es requerido" *ngIf="!userform.controls['name'].valid&&userform.controls['name'].dirty"></p-message>
          </div>
        </div>
      </div>
      <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
        <div class="ui-g-12" style="color: #073c8f;">
            <h2 style="font-family: poppins; font-weight: 600;">País</h2>
        </div>
       
        <div class="ui-g-12" style="margin-bottom: 2%;">
          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12">
              <p-dropdown [options]="items" formControlName="country"  placeholder="{{countryTitle}}" optionLabel="name" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
            </div>
          </div>
        </div>
        <div class="ui-g-12" style="margin-bottom: 2%;">
          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12" *ngIf="departments?.length > 0">
              <p-dropdown [options]="departments" formControlName="department"  placeholder="selecciona Departamento:" optionLabel="dept" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="seleccione departamento" *ngIf="!userform.controls['department'].valid&&userform.controls['department'].dirty"></p-message>
            </div>
          </div>
          <!--<div class="ui-grid-row item-login">
            <div class="ui-grid-col-12" *ngIf="towns?.length > 0">
              <p-dropdown [options]="towns" formControlName="town"  placeholder="Selecciona ciudad:" optionLabel="munName" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="country requerido" *ngIf="!userform.controls['town'].valid&&userform.controls['town'].dirty"></p-message>
            </div>
          </div>
          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12" *ngIf="zones?.length > 0">
              <p-dropdown [options]="zones" formControlName="zone"  placeholder="Selecciona Zona:" optionLabel="zoneName" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="country requerido" *ngIf="!userform.controls['zone'].valid&&userform.controls['zone'].dirty"></p-message>
            </div>
          </div>-->
          <div class="ui-g-12" style="color: #073c8f;">
              <h2 style="font-family: poppins; font-weight: 600;">Servicios</h2>
          </div>

          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12" *ngIf="services?.length > 0">
              <p-dropdown [options]="services" formControlName="services"  placeholder="Selecciona tipo de servicio:" optionLabel="strDescription" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="tipo de servicio es requerido" *ngIf="!userform.controls['zone'].valid&&userform.controls['zone'].dirty"></p-message>
            </div>
          </div>
          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12" *ngIf="specialties?.length > 0">
              <p-dropdown [options]="specialties" formControlName="specialties"  placeholder="Selecciona Especialidad:" optionLabel="strDescription" [showClear]="true" [virtualScroll]="true" [itemSize]="31" [filter]="true"></p-dropdown>
              <p-message severity="error" text="especialidad es requerida" *ngIf="!userform.controls['zone'].valid&&userform.controls['zone'].dirty"></p-message>
            </div>
          </div>
        </div>

        <!--<div class="ui-grid-row item-login">
          <div class="ui-grid-col-12">
            <h2 style="text-align: center; color: #073c8f; font-family: poppins; font-weight: 600;">Telemedicina</h2>
            <div class="ui-g-12" style="margin: 0 15%;">
              <div class="ui-g-6">
                <div class="p-field-radiobutton">
                  <p-radioButton inputId="no" name="telemedicine" value="{{false}}" [(ngModel)]="telemedicine"></p-radioButton>
                  <label for="no">No</label>
                </div>
              </div>
              <div class="ui-g-6">
                <div class="p-field-radiobutton">
                  <p-radioButton name="telemedicine" value="{{true}}" [(ngModel)]="telemedicine" inputId="si"></p-radioButton>
                  <label for="si">Si</label>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        
        <div class="ui-g-12">
          <div class="ui-grid-row item-login">
            <div class="ui-grid-col-12">
              <button pButton type="submit" label={{loginBtnTitle}} class=""></button>
            </div>
          </div>
        </div>
      </form>
    
    </div>
  </div>
  
</div>
